import type { ProductRef } from "schemas/product";

import { z } from "zod";

export type ItemsConfigType = "productImages" | "inline" | "htmlAttributes";

type ProductImagesConfig = {
  type: "productImages";
  productRef?: ProductRef;
};

type InlineItemsValues =
  | {
      valueType: "string";
      values: { id: string; value: string | undefined }[] | null;
    }
  | {
      valueType: "dynamic";
      dynamicPath: string;
    };

export type InlineItemsConfig = {
  type: "inline";
} & InlineItemsValues;

type HTMLAttributeTypes = "dataset";

export type HTMLAttributesValues = {
  id: string;
  valueType: HTMLAttributeTypes;
  key: string | undefined;
  value: string | undefined;
};

export type HTMLAttributesConfig = {
  type: "htmlAttributes";
  values: HTMLAttributesValues[];
};
export type ItemsConfig =
  | ProductImagesConfig
  | InlineItemsConfig
  | HTMLAttributesConfig;

// NOTE (Matt 2025-03-03): Below are the updated Dynamic Data Prop types, or types related to the way
// Dynamic Data is defined as a prop in component JSON. The above types will be deprecated in the future.

const dateFormatOptionsSchema = z.discriminatedUnion("format", [
  z.object({
    format: z.literal("text"),
    includeYear: z.boolean(),
    includeWeekday: z.boolean(),
  }),
  z.object({
    format: z.literal("number"),
    order: z.enum(["month-first", "day-first"]),
    separator: z.enum(["-", "/"]),
    includeYear: z.boolean(),
  }),
]);

export type DateFormatOptions = z.infer<typeof dateFormatOptionsSchema>;

export type ReferenceType = "currency" | "date";

export const formatterSchema = z.union([
  z.union([
    z.object({
      type: z.literal("discount"),
      discountType: z.literal("selectedSellingPlan"),
    }),
    z.object({
      type: z.literal("discount"),
      discountType: z.literal("specificSellingPlan"),
      sellingPlanId: z.number(),
    }),
  ]),
  z.object({
    // If this is present, use the currently active currency to format (use existing formatting logic)
    type: z.literal("currency"),
    showCurrencyCode: z.boolean().optional(),
  }),
  z.object({
    // If this is present, round the price to the nearest whole number
    type: z.literal("rounded"),
  }),
  z.object({
    // If this is present, round the price to the nearest whole number
    type: z.literal("quantityMultiplier"),
  }),
  z.object({
    type: z.literal("date"),
    dateOptions: dateFormatOptionsSchema,
  }),
]);

export type Formatter = z.infer<typeof formatterSchema>;
